import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import VehicleModelDrawer from "components/drawer/VehicleModelDrawer";
import ViewModal from "components/modal/ViewVehiceleCategoryModal";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { FiEye } from "react-icons/fi";
import Tooltip from "components/tooltip/Tooltip";

const VehicleModelTable = ({
  vehicleCategory,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
    isViewMode,
    handleView,
  } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vehicleCategory} />
      <MainDrawer>
        <VehicleModelDrawer id={serviceId} isViewMode={isViewMode} />
      </MainDrawer>

      <TableBody>
        {vehicleCategory?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold uppercase text-xs text-center">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-sm text-center">
              {data["vehicle_type_name"] || "-"}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data.vehicle_names?.length > 0
                ? data.vehicle_names.map((item, index) => (
                    <p key={index}>{item || "-"}</p>
                  ))
                : "-"}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["seats"] || "-"}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["no_of_bags"] || "-"}
            </TableCell>

            <TableCell className="text-sm text-center">
              {data["no_of_small_bags"] || "-"}
            </TableCell>

            <TableCell
              className="text-sm text-center"
              style={{ minWidth: "100px" }}
            >
              {data["image"] ? (
                <img
                  style={{
                    objectFit: "contain",
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                  }}
                  src={process.env.REACT_APP_API_IMAGE_URL + data["image"]}
                  alt="caricon"
                />
              ) : (
                <p className="text-center"> -</p>
              )}
            </TableCell>

            <TableCell style={{ minWidth: "100px" }}>
              {data["prime"] ? (
                <img
                  style={{
                    objectFit: "contain",
                    width: "80px",
                    height: "80px",
                    margin: "0 auto",
                  }}
                  src={process.env.REACT_APP_API_IMAGE_URL + data["prime"]}
                  alt="caricon"
                />
              ) : (
                <p className="text-center"> -</p>
              )}
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                  <button
                    onClick={() =>
                      handleView(data.id, "Vehicle Category Details")
                    }
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  >
                    <Tooltip
                      id={data.id}
                      Icon={FiEye}
                      title="ViewOrder"
                      bgColor="#34D399"
                    />
                  </button>
                </div>
                <EditDeleteButton
                  title={data["Vehicle Category"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  // hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default VehicleModelTable;
